import { ArrowDownCircle, ArrowUpCircle, Hand, Hourglass, Wallet } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

const STYLE = {
  "BUY UP": { cls: "text-[#34D399] bg-emerald-500/10 border-emerald-500/40", icon: ArrowUpCircle, title: "Practice bot opened a simulated Up position" },
  "BUY DOWN": { cls: "text-[#F87171] bg-red-500/10 border-red-500/40", icon: ArrowDownCircle, title: "Practice bot opened a simulated Down position" },
  "CASH OUT": { cls: "text-[#FBBF24] bg-amber-500/10 border-amber-500/40", icon: Wallet, title: "Practice bot closed its simulated position" },
  HOLD: { cls: "text-[#60A5FA] bg-blue-500/10 border-blue-500/40", icon: Hand, title: "Practice bot is holding a simulated position" },
  WAIT: { cls: "text-slate-300 bg-slate-500/10 border-slate-500/40", icon: Hourglass, title: "Practice bot is not trading" },
};

const Bar = ({ label, value, color, testid }) => (
  <div>
    <div className="flex justify-between text-xs"><span className="text-slate-400">{label}</span><span className="font-num font-semibold" data-testid={testid}>{Math.round(value * 100)}%</span></div>
    <div className="h-2 rounded-full bg-[#1A2338] mt-1 overflow-hidden"><div className={`h-full ${color} transition-[width] duration-700`} style={{ width: `${value * 100}%` }} /></div>
  </div>
);

export const SignalCard = ({ live }) => {
  if (!live) return <section className="card p-5 h-full"><Skeleton className="h-60 bg-[#111A2C]" /></section>;
  const s = STYLE[live.signal] || STYLE.WAIT;
  const updated = new Date(live.updated).toLocaleTimeString();
  return (
    <section className="card p-5 sm:p-6 h-full fade-up" data-testid="signal-card">
      <div className="flex justify-between items-center">
        <div className="text-xs uppercase tracking-widest font-num text-slate-400">Practice bot (fake money)</div>
        <div className="text-[10px] font-num text-slate-500" data-testid="signal-updated">checked {updated} · every 10s</div>
      </div>
      <div className={`mt-3 rounded-xl border p-4 ${s.cls}`}>
        <div className="flex items-center gap-3">
          <s.icon className="w-9 h-9 shrink-0" />
          <div>
            <div className="font-head font-extrabold text-3xl tracking-tight" data-testid="signal-label">{live.signal}</div>
            <div className="text-sm opacity-90">{s.title}</div>
          </div>
        </div>
      </div>
      <p className="text-sm text-slate-200 leading-relaxed mt-4" data-testid="signal-reason">
        <span className="text-slate-400">Why: </span>{live.reason}
      </p>
      <div className="mt-5 space-y-3">
        <div className="text-[10px] uppercase tracking-widest font-num text-slate-400">Chance BTC finishes UP</div>
        <Bar label="Model estimate (statistical, unvalidated)" value={live.model_up} color="bg-[#22D3EE]" testid="model-up-prob" />
        <Bar label="Market-implied (Polymarket US order-book midpoint)" value={live.market_up} color="bg-slate-400" testid="market-up-prob" />
        <p className="text-[11px] text-slate-500 leading-relaxed">
          The practice bot simulates trades only when the model diverges from the market. Historical backtests have not shown the
          model beating the market price, so these simulated trades are an experiment, not advice.
        </p>
      </div>
      <div className="mt-4 flex flex-wrap gap-2 text-[11px] font-num">
        <span className="px-2 py-1 rounded border border-[#1A2338] text-slate-400" data-testid="trend-momentum">Trend: {live.btc.momentum}</span>
        <span className="px-2 py-1 rounded border border-[#1A2338] text-slate-400">1m {live.btc.change_1m >= 0 ? "+" : ""}${live.btc.change_1m.toFixed(0)}</span>
        <span className="px-2 py-1 rounded border border-[#1A2338] text-slate-400">5m {live.btc.change_5m >= 0 ? "+" : ""}${live.btc.change_5m.toFixed(0)}</span>
        <span className="px-2 py-1 rounded border border-[#1A2338] text-slate-400">15m {live.btc.change_15m >= 0 ? "+" : ""}${live.btc.change_15m.toFixed(0)}</span>
      </div>
    </section>
  );
};
